// Shared constants for the Tasks PM tool. Mirrors what the backend writes
// into cp_tasks.status / cp_tasks.priority — keep these arrays in sync with
// the STATUS_LABELS map in netlify/functions/neon.js (cp_tasks_upsert).

export const STATUSES = [
  { id: 'backlog',     label: 'Backlog',     color: '#6b7280', bg: '#f3f4f6' },
  { id: 'planned',     label: 'Planned',     color: '#0e7490', bg: '#ecfeff' },
  { id: 'in_progress', label: 'In Progress', color: '#DC582A', bg: '#fff7ed' },
  { id: 'blocked',     label: 'Blocked',     color: '#dc2626', bg: '#fef2f2' },
  { id: 'review',      label: 'In Review',   color: '#7c3aed', bg: '#f5f3ff' },
  { id: 'done',        label: 'Done',        color: '#15803d', bg: '#f0fdf4' },
];

export const STATUS_BY_ID = Object.fromEntries(STATUSES.map(s => [s.id, s]));

export const ROADMAP_STATUSES = ['planned', 'in_progress', 'blocked', 'review'];
export const BACKLOG_STATUSES = ['backlog'];

export const PRIORITIES = [
  { id: 'critical', label: 'Critical', color: '#dc2626', flag: '🚨' },
  { id: 'high',     label: 'High',     color: '#EA733D', flag: '🔥' },
  { id: 'medium',   label: 'Medium',   color: '#00395C', flag: '◆'  },
  { id: 'low',      label: 'Low',      color: '#6b7280', flag: '·'  },
];

export const PRIORITY_BY_ID = Object.fromEntries(PRIORITIES.map(p => [p.id, p]));

// Fixed (non-Epic) views. The Tasks page renders dynamic Epic tabs in front
// of these (loaded from cp_task_epics). The original "Roadmap" tab moved
// to be the first Epic — "VIP Ready" — and additional Epics surface here too.
export const FIXED_VIEWS = [
  { id: 'backlog', label: 'Backlog',  hint: 'Ideas + future work, grouped by area' },
  { id: 'mine',    label: 'My Tasks', hint: 'Assigned to you (excluding Backlog/Done)' },
  { id: 'all',     label: 'All',      hint: 'Everything (filterable)' },
];

// Statuses an Epic tab surfaces (same set as the old Roadmap view).
export const EPIC_TAB_STATUSES = ROADMAP_STATUSES;
